import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["collapsedBtn", "compressedBtn"]

  connect() {
    // Restore saved preference
    const saved = localStorage.getItem("movements-view-mode") || "collapsed"
    if (saved === "compressed") {
      this.applyCompressed()
    } else {
      this.applyCollapsed()
    }
  }

  setCollapsed() {
    localStorage.setItem("movements-view-mode", "collapsed")
    this.applyCollapsed()
  }

  setCompressed() {
    localStorage.setItem("movements-view-mode", "compressed")
    this.applyCompressed()
  }

  applyCollapsed() {
    const table = document.getElementById("movements-table")
    if (table) {
      table.setAttribute("data-view-mode", "collapsed")
    }
    this.updateButtons("collapsed")
  }

  applyCompressed() {
    const table = document.getElementById("movements-table")
    if (table) {
      table.setAttribute("data-view-mode", "compressed")
    }
    this.updateButtons("compressed")
  }

  updateButtons(mode) {
    if (this.hasCollapsedBtnTarget && this.hasCompressedBtnTarget) {
      const activeClasses = ["bg-indigo-100", "text-indigo-700"]
      const inactiveClasses = ["text-gray-500", "hover:text-gray-700"]

      if (mode === "collapsed") {
        this.collapsedBtnTarget.classList.add(...activeClasses)
        this.collapsedBtnTarget.classList.remove(...inactiveClasses)
        this.compressedBtnTarget.classList.remove(...activeClasses)
        this.compressedBtnTarget.classList.add(...inactiveClasses)
      } else {
        this.compressedBtnTarget.classList.add(...activeClasses)
        this.compressedBtnTarget.classList.remove(...inactiveClasses)
        this.collapsedBtnTarget.classList.remove(...activeClasses)
        this.collapsedBtnTarget.classList.add(...inactiveClasses)
      }
    }
  }
}
